var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConnectwifi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12V68C79.5 74.3513 74.3513 79.5 68 79.5H12C5.64873 79.5 0.5 74.3513 0.5 68V12C0.5 5.64873 5.64873 0.500001 12 0.5Z",
    fill: "url(#paint0_linear_359_122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12V68C79.5 74.3513 74.3513 79.5 68 79.5H12C5.64873 79.5 0.5 74.3513 0.5 68V12C0.5 5.64873 5.64873 0.500001 12 0.5Z",
    stroke: "url(#paint1_linear_359_122)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7578 45.6223C58.5587 45.6223 60.0185 47.0822 60.0186 48.8831V59.551C60.0185 61.3519 58.5587 62.8118 56.7578 62.8118H23.8076C22.0068 62.8117 20.547 61.3518 20.5469 59.551V48.8831C20.5469 47.0822 22.0068 45.6224 23.8076 45.6223H56.7578ZM26.9141 49.4426L30.0986 58.8821H33.1357L36.3203 49.4426H33.7676L31.6562 56.3557H31.5781L29.4668 49.4426H26.9141ZM37.3369 58.8821H39.6182V55.9504H41.167C41.8889 55.9504 42.5127 55.8173 43.0381 55.55C43.5635 55.2827 43.9673 54.9056 44.25 54.4202C44.5357 53.9316 44.6787 53.3616 44.6787 52.7102C44.6787 52.062 44.5393 51.4936 44.2598 51.0051C43.9802 50.5135 43.5816 50.1311 43.0654 49.8577C42.5524 49.5812 41.9428 49.4427 41.2363 49.4426H37.3369V58.8821ZM45.8027 58.8821H48.085V53.4338H48.1445L51.9004 58.8821H53.8369V49.4426H51.5596V54.8811H51.4814L47.7666 49.4426H45.8027V58.8821ZM40.7432 51.2815C41.0841 51.2815 41.371 51.3406 41.6045 51.4573C41.8379 51.574 42.0149 51.7394 42.1348 51.9543C42.2546 52.1663 42.3144 52.4184 42.3145 52.7102C42.3145 52.999 42.2546 53.2528 42.1348 53.4709C42.0149 53.686 41.838 53.8531 41.6045 53.9729C41.3741 54.0927 41.0872 54.1526 40.7432 54.1526H39.6182V51.2815H40.7432Z",
    fill: "#34D399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0029 22.7335C26.9555 21.5731 32.8008 19.2559 40.6029 19.2559C48.4049 19.2559 54.2502 21.5731 56.1986 22.7335M30.6592 30.1718C32.3179 29.4343 36.622 27.9557 40.6029 27.9557C44.5753 27.9557 48.8836 29.4343 50.5423 30.1718M37.3443 37.7186C38.3645 37.2834 39.4729 37.0364 40.6029 36.9924C41.9046 36.9924 43.3155 37.479 43.8572 37.7186",
    stroke: "#34D399",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_122",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_122",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 69.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectwifi);
export default __webpack_public_path__ + "static/media/icon-connectwifi.268401e056fba632da82ad8864a391bc.svg";
export { ForwardRef as ReactComponent };